import { addDoc, collection, deleteDoc, doc, Firestore, getDocs, Query, updateDoc } from 'firebase/firestore';
import { DBCollection } from '@/lib/utils/constants-shared';
import { flag_offline_timeout } from '../constants';

export async function fetchItemsFromDB<ItemType extends Item>(query: Query): Promise<ItemType[]> {
    const snapshot = await getDocs(query);
    return snapshot.docs.map(doc => ({...doc.data(), id: doc.id})) as ItemType[];
}

export async function insertItemToDB<ItemType>(db: Firestore, path: DBCollection, item: Omit<ItemType, 'id'>): Promise<ItemType> {
    return new Promise((resolve, reject) => {
        addDoc(collection(db, path), item).then(({id}) => resolve({...item, id} as ItemType)).catch(reject);
        setTimeout(() => reject(`Potential Timeout inserting in ${path}`), flag_offline_timeout);
    });
}

export async function updateItemToDB(db: Firestore, path: DBCollection, item: Item) {
    return new Promise((resolve, reject) => {
        updateDoc(doc(db, path, item.id), {...item}).then(resolve).catch(reject);
        setTimeout(() => reject(`Potential Timeout updating ${path}/${item.id}`), flag_offline_timeout);
    });
}

export async function removeItemFromDB(db: Firestore, path: DBCollection, id: string) {
    return new Promise((resolve, reject) => {
        deleteDoc(doc(db, path, id)).then(resolve).catch(reject);
        setTimeout(() => reject(`Potential Timeout removing ${path}/${id}`), flag_offline_timeout);
    });
}